import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { numberOfTriesList, taskFeatureList } from '../../../../../utils/constants';
import { useRef } from 'react';
import InputWithLabel from '../../../../../component/common/InputWithLabel';
import { Tooltip } from 'react-tooltip';
import Dots from '../../../../../assets/images/Dots.svg';
import ActiveDots from '../../../../../assets/images/active-dots.svg';
import warning from '../../../../../assets/svg/icons/Warning.svg';
import drag from '../../../../../assets/svg/icons/Drag.svg';
import FormSelect from '../../../../../component/common/FormSelect';
import toast from 'react-hot-toast';
import { useEffect } from 'react';
import RightArrow from '../../../../../assets/images/RightArrow.svg';

const initialTaskFormData = {
    id: '',
    feature: '',
    title: '',
    description: '',
    instruction: '',
    number_of_tries: '',
    connect_to_wearable: '',
    wellpoints: '',
    duration: '0',
    wellpoints: '',
};

const connectToWearable = [
    { id: 1, name: "connect", value: true },
    { id: 2, name: 'Not Connect', value: false },
]
const BadgeTaskForm = ({ data, setData, handleFinalSubmit, challange = false }) => {
    const [searchParams] = useSearchParams();
    const queryparams = Object.fromEntries(searchParams);
    const view = queryparams.view || 'edit';

    const TaskCard = ({ task, onDelete, onEdit, handleDragStart, handleDragEnter, handleDragEnd }) => {
        // const [cardId, setCardId] = useState(null);
        // const popupRef = useRef(null);
        // useEffect(() => {
        //     const handleClickOutside = (event) => {
        //         if (popupRef.current && !popupRef.current.contains(event.target)) {
        //             setCardId(null);
        //         }
        //     };

        //     document.addEventListener('mousedown', handleClickOutside);
        //     return () => {
        //         document.removeEventListener('mousedown', handleClickOutside);
        //     };
        // }, [popupRef]);
        // const handleButtonClick = () => {
        //     setCardId(prev => (prev === task.id ? null : task.id)); // toggle or open new
        // };
        const [cardId2, setCardId2] = useState(null);
        const popupRef2 = useRef(null);

        const handleButtonClick2 = (id) => {
            setCardId2(prev => prev === id ? null : id);
        };

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (popupRef2.current && !popupRef2.current.contains(event.target)) {
                    setCardId2(null);
                }
            };
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, []);

        return (
            <div className="bg-white gap-4 rounded-xl shadow-sm border border-gray-200 mb-4 p-3">
                {/* Card Header */}
                <div className="flex gap-4">
                    {/* Drag Image Section */}
                    <div
                        className="flex items-center justify-center min-w-[max-content]"
                        draggable
                        onDragStart={handleDragStart}
                        onDragEnter={handleDragEnter}
                        onDragEnd={handleDragEnd}
                        onDragOver={(e) => e.preventDefault()}
                    >
                        <img src={drag} alt="Drag" className="w-6 h-6 cursor-move" />
                    </div>

                    {/* Main Content */}
                    <div className="flex-1">
                        <div className="flex justify-between items-start mb-3">
                            <h2 className="font-medium flex-wrap text-gray-800 flex items-center gap-2">
                                {task.grouped_by}
                                <img
                                    id={task.id}
                                    src={warning}
                                    alt="Warning"
                                    className="w-6 h-6 cursor-pointer"
                                />
                                <Tooltip
                                    anchorSelect={`#${task.id}`}
                                    place="top"
                                    content={task.msg}
                                    className="max-w-xs break-words z-50"
                                    style={{ zIndex: 9999 }}
                                />
                            </h2>

                            {/* <div className="relative" ref={popupRef}>
                                <button onClick={handleButtonClick}>
                                    <img src={Dots} alt="Menu" className="w-7 h-6 block dark:hidden" />
                                    <img src={ActiveDots} alt="Menu Active" className="w-6 h-6 hidden dark:block" />
                                </button>

                                {cardId === task.id && (
                                    <div className="w-35 z-50 bg-white dark:bg-shoorah-darkBgTabColor 
                                    absolute top-4 right-0 mt-2 border-[1.5px] rounded-lg shadow-lg">
                                        <div
                                            className="py-2 px-5 hover:bg-gray-100 cursor-pointer text-black font-medium"
                                        >
                                            Edit
                                        </div>
                                        <div className="border-b border-gray-400 w-full"></div>
                                        <div
                                            className="py-2 px-5 hover:bg-gray-100 cursor-pointer text-red-700 font-medium"
                                            onClick={() => {
                                                onDelete(task.id);
                                                setCardId(null);
                                            }}
                                        >
                                            Delete
                                        </div>
                                    </div>
                                )}
                            </div> */}
                        </div>

                        {task?.sub_tasks?.map((t) => (
                            <div
                                key={t.id}
                                className="bg-[#F4F5F6] px-4 py-3 rounded-lg mb-2 border border-gray-100 flex justify-between items-start"
                            >
                                <div>
                                    <p className="font-medium text-gray-800">{t.title}</p>
                                    <p className="text-sm text-gray-500">{t.description}</p>
                                </div>
                                <div className="relative" >
                                    <button onClick={() => handleButtonClick2(t.id)}>
                                        <img src={Dots} alt="Menu" className="w-7 h-6 block dark:hidden" />
                                        <img src={ActiveDots} alt="Menu Active" className="w-6 h-6 hidden dark:block" />
                                    </button>

                                    {cardId2 === t.id && (
                                        <div ref={popupRef2}
                                            className="w-35 z-50 bg-white absolute top-4 right-0 mt-2 border-[1.5px] rounded-lg shadow-lg"
                                        >
                                            <div
                                                className="py-2 px-5 hover:bg-gray-100 cursor-pointer text-black font-medium"
                                                onClick={() => {
                                                    onEdit(task.grouped_by, t);
                                                    setCardId2(null); // Close menu after edit
                                                }}
                                            >
                                                Edit
                                            </div>
                                            <div className="border-b border-gray-400 w-full" />
                                            <div
                                                className="py-2 px-5 hover:bg-gray-100 cursor-pointer text-red-700 font-medium"
                                                onClick={() => {
                                                    onDelete(task.grouped_by, t);
                                                    setCardId2(null); // Close menu after delete
                                                }}
                                            >
                                                Delete
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    const DraggableCardGrid = ({ tasks, setTasks, setFormData, onEdit, onDelete }) => {
        const dragCardIndex = useRef(null);
        const dragOverCardIndex = useRef(null);
        const handleDragStart = (index) => {
            dragCardIndex.current = index;
        };

        const handleDragEnter = (index) => {
            dragOverCardIndex.current = index;
        };

        const handleDragEnd = () => {
            const updatedCards = [...tasks];
            const draggedCard = updatedCards[dragCardIndex.current];
            updatedCards.splice(dragCardIndex.current, 1);
            updatedCards.splice(dragOverCardIndex.current, 0, draggedCard);
            setTasks(updatedCards);
            dragCardIndex.current = null;
            dragOverCardIndex.current = null;
        };

        return (
            <div className="grid grid-cols-1 gap-4">
                <div className="grid grid-cols-1 max-w-[900px]">
                    {tasks.map((task, index) => (
                        <TaskCard
                            key={task.id}
                            task={task}
                            tasks={tasks}
                            setTasks={setTasks}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            setFormData={setFormData}
                            handleDragStart={() => handleDragStart(index)}
                            handleDragEnter={() => handleDragEnter(index)}
                            handleDragEnd={handleDragEnd}
                        />
                    ))}
                </div>
            </div>
        );
    };

    const TaskForm = () => {
        const [tasks, setTasks] = useState(data?.tasks || []);
        const [formData, setFormData] = useState(initialTaskFormData);
        const [editTaskId, setEditTaskId] = useState(null);
        const formRef = useRef(null);

        console.log(formData, "formDataformData", tasks, "tasks");

        const handleDelete = (grouped_by, subTask) => {
            console.log("Delete clicked:", grouped_by, subTask);
            const updatedTasks = tasks
                .map(task => {
                    if (task.grouped_by === grouped_by) {
                        const updatedSubTasks = task.sub_tasks.filter(st => st.id !== subTask.id);
                        return { ...task, sub_tasks: updatedSubTasks };
                    }
                    return task;
                })
                .filter(task => task.sub_tasks.length > 0); // Remove group if empty

            setTasks(updatedTasks);
            toast.success('Task deleted');
            setFormData(initialTaskFormData);
            setEditTaskId(null);
        };
        const handleEdit = (grouped_by, subTask) => {
            console.log("Edit clicked:", grouped_by, subTask);
            if (subTask) {
                setFormData({
                    ...subTask,
                    connect_to_wearable: subTask.connect_to_wearable ? "true" : "false",
                });
                setEditTaskId({ grouped_by, id: subTask.id });

                // Scroll to form
                setTimeout(() => {
                    formRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 0);
            }
        };

        useEffect(() => {
            if (JSON.stringify(data.tasks) !== JSON.stringify(tasks)) {
                setData((prev) => ({ ...prev, tasks }));
            }
        }, [tasks]);

        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData((prev) => ({ ...prev, [name]: value }));
        };
        const handleChange2 = (name, value) => {
            setFormData((prev) => ({
                ...prev,
                [name]: value
            }));
        };

        const handleSubmit = async (e) => {
            e.preventDefault();

            const { feature, title, description, instruction, number_of_tries, wellpoints, duration,connect_to_wearable } = formData;

            // Validation
            if (!title) return toast.error('Title is required');
            if (!feature) return toast.error('Task feature is required');
            if (!description) return toast.error('Task description is required');
            if (!number_of_tries) return toast.error('Number of tries is required');
            if (!wellpoints) return toast.error('Wellpoints is required');
            if (!duration) return toast.error('Duration is required');
            if (challange && !connect_to_wearable) return toast.error('Connect to wearable is required');
            if (editTaskId) {
                console.log("id---------->")
                const updatedTasks = tasks.map(task => {
                    if (task.grouped_by === editTaskId.grouped_by) {
                        const updatedSubTasks = task.sub_tasks.map((sub) =>
                            sub.id === editTaskId.id ? {
                                ...sub, ...formData,
                                connect_to_wearable: connect_to_wearable === 'true',
                            } : sub
                        );
                        return { ...task, sub_tasks: updatedSubTasks };
                    }
                    return task;
                });

                setTasks(updatedTasks);
                toast.success('Task updated');
                setEditTaskId(null);
                setFormData(initialTaskFormData);
                return;
            }

            const selectedFeature = taskFeatureList.find(item => item.value === feature);

            if (!selectedFeature) return toast.error('Selected feature is invalid');
            const grouped_by = selectedFeature.groubedBy;
            const msg = selectedFeature.msg;
            // 🔒 Check if this feature is already used in any task
            const isFeatureAlreadyUsed = tasks.some(task =>
                task.sub_tasks.some(sub => sub.feature === feature)
            );

            if (isFeatureAlreadyUsed) {
                toast.error(`Selected feature "${feature}" already has a task.`);
                return;
            }
            // Check if a task group already exists by grouped_by
            const existingTaskGroup = tasks.find(task => task.grouped_by === grouped_by);

            const newSubTask = {
                id: Math.random(90000, 99999).toFixed(),
                title,
                feature: feature,
                backend_name: selectedFeature?.backendName,
                description,
                instruction,
                number_of_tries,
                wellpoints,
                duration,
                connect_to_wearable,
                status: "draft"
            };

            if (existingTaskGroup) {
                // Add subtask to existing group
                const updatedTasks = tasks.map(task =>
                    task.grouped_by === grouped_by
                        ? { ...task, sub_tasks: [...task.sub_tasks, newSubTask] }
                        : task
                );

                setTasks(updatedTasks);
                toast.success(`Task added under '${grouped_by}' group!`);
            } else {
                // Create new task group
                const newTask = {
                    id: `tooltip-${grouped_by.replace(/\s+/g, '-').toLowerCase()}-${Math.random(90000, 99999).toFixed()}`,
                    grouped_by,
                    msg,
                    sub_tasks: [newSubTask],
                };

                setTasks(prev => [...prev, newTask]);
                toast.success(`New task group '${grouped_by}' created!`);
            }

            setFormData(initialTaskFormData);
        };

        return (
            <div>
                {tasks?.length > 0 && <div className="h-full mt-[10px]">
                    <DraggableCardGrid
                        setFormData={setFormData}
                        onEdit={handleEdit}
                        tasks={tasks}
                        setTasks={setTasks}
                        onDelete={handleDelete}
                    />
                </div>}
                <div ref={formRef} className="h-full p-6 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl mt-[15px]">
                    <div className="h-full flex flex-col sm:flex-row items-start md:gap-4 gap-2">
                        <div className="space-y-4 max-w-[846px] w-full">
                            <form onSubmit={handleSubmit}>
                                <InputWithLabel
                                    label={'Task Title'}
                                    placeholder={'Task Title'}
                                    containerClassName={'w-full'}
                                    onChange={handleChange}
                                    value={formData?.title}
                                    name={'title'}
                                    disabled={view === 'preview' || view === 'preview_only'}
                                />
                                <div className="text-[16px] text-shoorah-lightBlack mt-3 sm:w-full max-w-[846px] dark:text-shoorah-darkBg">
                                    <label htmlFor="description" className="font-medium text-[16px] leading-9 mb-1">
                                        Task Description
                                    </label>
                                    <div className="input-field">
                                        <textarea
                                            className="w-full block rounded-lg px-4 py-2 text-[14px] bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray min-h-[100px] resize-none mb-0 dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-none focus:outline-none"
                                            value={formData?.description}
                                            name="description"
                                            id="description"
                                            placeholder="Enter description: e.g Take this assessment to find out if you may have symptoms of social anxiety."
                                            onChange={handleChange}
                                            maxLength={500}
                                            disabled={view === 'preview' || view === 'preview_only'}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="text-[16px] text-shoorah-lightBlack mt-3 sm:w-full max-w-[846px] dark:text-shoorah-darkBg">
                                    <label htmlFor="description" className="font-medium flex flex-wrap text-[16px] leading-9 mb-1 gap-5">
                                        Task Instruction (optional)
                                        <img
                                            id='1'
                                            src={warning}
                                            alt="Warning"
                                            className="w-6 h-6 cursor-pointer"
                                        />
                                        <Tooltip
                                            anchorSelect={`#1`}
                                            place="top"
                                            content="rrrrr"
                                            className="max-w-xs break-words z-50"
                                            style={{ zIndex: 9999 }}
                                        />
                                    </label>
                                    <div className="input-field">
                                        <textarea
                                            className="w-full block rounded-lg px-4 py-2 text-[14px] bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray min-h-[100px] resize-none mb-0 dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-none focus:outline-none"
                                            value={formData?.instruction}
                                            name="instruction"
                                            id="instruction"
                                            placeholder="Enter description: e.g Take this assessment to find out if you may have symptoms of social anxiety."
                                            onChange={handleChange}
                                            maxLength={500}
                                            disabled={view === 'preview' || view === 'preview_only'}
                                        ></textarea>
                                    </div>
                                </div>
                                {/* First Row */}
                                <div className="flex flex-col sm:flex-row justify-between gap-5 mt-3 w-full h-full items-center">
                                    <div className="flex w-full flex-col min-w-[150px]">
                                        <InputWithLabel
                                            label="Task Wellpoints"
                                            placeholder="Task Wellpoints"
                                            containerClassName="w-full"
                                            type="number"
                                            onChange={handleChange}
                                            value={formData?.wellpoints}
                                            name="wellpoints"
                                            disabled={view === 'preview' || view === 'preview_only'}
                                        />
                                    </div>
                                    <div className="flex w-full flex-col min-w-[150px]">
                                        <InputWithLabel
                                            label="Duration (Days)"
                                            placeholder="Duration"
                                            containerClassName="w-full"
                                            type="number"
                                            onChange={handleChange}
                                            value={formData?.duration}
                                            name="duration"
                                            disabled={view === 'preview' || view === 'preview_only'}
                                        />
                                    </div>
                                </div>

                                {/* Second Row */}
                                <div className="flex flex-col sm:flex-row justify-between gap-5 mt-3 w-full h-full items-center">
                                    <div className="flex w-full flex-col min-w-[150px]">
                                        <FormSelect
                                            key={formData.feature}
                                            label="Task Feature"
                                            options={taskFeatureList}
                                            name="feature"
                                            placeholder='Task Feature'
                                            onChange={handleChange2}
                                            value={formData?.feature || ''}
                                            disabled={view === 'preview' || view === 'preview_only'}
                                        />
                                    </div>
                                    <div className="flex w-full flex-col min-w-[150px]">
                                        <FormSelect
                                            key={formData.number_of_tries}
                                            label="Number of tries"
                                            placeholder='Number of tries'
                                            options={numberOfTriesList}
                                            name="number_of_tries"
                                            onChange={handleChange2}
                                            value={formData?.number_of_tries || ''}
                                            disabled={view === 'preview' || view === 'preview_only'}
                                        />
                                    </div>
                                    {challange && (
                                        <div className="flex w-full flex-col min-w-[150px]">
                                            <FormSelect
                                                key={formData.connect_to_wearable}
                                                label="Connect to wearable"
                                                options={connectToWearable}
                                                name="connect_to_wearable"
                                                onChange={handleChange2}
                                                value={formData?.connect_to_wearable || ''}
                                                disabled={view === 'preview' || view === 'preview_only'}
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className="flex flex-row w-full h-full justify-start mt-3">
                                    <button
                                        type='submit'
                                        className="bg-indigo-500 hover:bg-indigo-600 text-white px-6 py-2 rounded-full transition-all 
                                 flex items-center gap-2">
                                        Save task
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end mt-3">
                    {
                        <button
                            onClick={handleFinalSubmit}
                            type="button"
                            className="inline-flex text-xs sm:text-base font-medium items-center justify-center rounded-3xl border bg-shoorah-secondary px-5 py-2 text-white hover:shoorah-primary focus:outline-none w-full sm:w-auto"
                        >
                            Save & Continue
                            <img className="ml-2" src={RightArrow} alt="edit" />
                        </button>
                    }
                </div>
            </div>
        );
    };

    return (
        <div>
            <TaskForm />
        </div>
    )
}

export default BadgeTaskForm